import { createBreakpoints } from '@ori-ui/mui-bundle/system';
const breakpoints = createBreakpoints({
  values: {
    xs: 0,
    sm: 600,
    md: 900,
    lg: 1200,
    xl: 1536
  }
});
export default breakpoints;
//# sourceMappingURL=breakpoints.js.map